export default class ManExp {
    /**
     * @param {number} mantissa
     * @param {number} exponent
     */
    constructor(mantissa, exponent) {
        /**
         * @type {number}
         */
        this.m = mantissa;
        /**
         * @type {number}
         */
        this.e = exponent;
    }

    /**
     * @param {number} mantissa
     * @param {number} exponent
     * @returns {ManExp}
     */
    set(mantissa, exponent) {
        this.m = mantissa;
        this.e = exponent;
        return this;
    }

    /**
     * Sets the value to 0.
     * @returns {ManExp}
     */
    setZero() {
        this.m = 0;
        this.e = 0;
        return this;
    }

    /**
     * @param {ManExp} source 
     * @returns {ManExp}
     */
    copy(source) {
        if (typeof source === "number") {
            console.log('ManExp.copy() passed number instead of ManExp');
            console.trace();
        }

        this.m = source.m;
        this.e = source.e;
        return this;
    }

    /**
     * @param {ManExp} value 
     * @returns {boolean}
     */
    lessThan(value) {
        if (typeof value === "number") {
            console.log('ManExp.lessThan() passed number instead of ManExp');
            console.trace();
        }

        if (this.m === 0) {
            return value.m > 0;
        }

        if (value.m === 0) {
            return this.m <= 0;
        }

        if (this.e === value.e) {
            return this.m < value.m;
        }

        if (this.m > 0) {
            return value.m > 0 && this.e < value.e;
        }

        return value.m > 0 || this.e > value.e;
    }

    /**
     * @param {ManExp} value 
     * @returns {boolean}
     */
    lessThanEquals(value) {
        return !this.greaterThan(value);
    }

    /**
     * @param {ManExp} value 
     * @returns {boolean}
     */
    greaterThan(value) {
        if (typeof value === "number") {
            console.log('ManExp.greaterThan() passed number instead of ManExp');
            console.trace();
        }

        if (this.m === 0) {
            return value.m < 0;
        }

        if (value.m === 0) {
            return this.m > 0;
        }

        if (this.e === value.e) {
            return this.m > value.m;
        }

        if (this.m > 0) {
            return value.m < 0 || this.e > value.e;
        }

        return value.m < 0 && this.e < value.e;
    }

    /**
     * @param {ManExp} value 
     * @returns {boolean}
     */
    greaterThanEquals(value) {
        return !this.lessThan(value);
    }

    /**
     * @param {ManExp} value 
     * @returns {number} -1, 0, 1
     */
    compare(value) {
        if (typeof value === "number") {
            console.log('ManExp.compare() passed number instead of ManExp');
            console.trace();
        }

        if (this.m === 0) {
            if (value.m === 0) {
                return 0;
            }

            if (value.m < 0) {
                return 1;
            }

            if (value.m > 0) {
                return -1;
            }
        }

        if (value.m === 0) {
            if (this.m < 0) {
                return -1;
            }

            if (this.m > 0) {
                return 1;
            }
        }

        if (this.m > 0) {
            if (value.m < 0) {
                return 1;
            }

            if (this.e > value.e) {
                return 1;
            }

            if (this.e < value.e) {
                return -1;
            }

            if (this.m > value.m) {
                return 1;
            }

            if (this.m < value.m) {
                return -1;
            }

            return 0;
        }

        if (this.m < 0) {
            if (value.m > 0) {
                return -1;
            }

            if (this.e > value.e) {
                return -1;
            }

            if (this.e < value.e) {
                return 1;
            }

            if (this.m > value.m) {
                return 1;
            }

            if (this.m < value.m) {
                return -1;
            }

            return 0;
        }
    }

    /**
     * @param {ManExp} value 
     * @returns {boolean}
     */
    equals(value) {
        // if (typeof value === "number") {
        //     console.log('ManExp.equals() passed number instead of ManExp');
        //     console.trace();
        // }

        return this.e === value.e && this.m === value.m;
    }

    /**
     * @returns {boolean}
     */
    equalsZero() {
        return this.e === 0 && this.m === 0;
    }
}